//Bootstrap JS
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bxslider-clean/src/js/jquery.bxslider'
import 'historyjs/scripts/bundled-uncompressed/html5/jquery.history'
import './rail_theme'
import 'sharer.js'
const $ = require('jquery');
require('jquery-inview');

//glightbox
import GLightbox from 'glightbox';

import { setupRecaptcha } from "./recaptcha";
import {setupRailTheme} from "./rail_theme";


setupRecaptcha();

setupRailTheme();

GLightbox({
    selector: '.glightbox'
});


let lgMaxWidth = window.matchMedia("(max-width: 991.9px)");

matchMediaHandler(lgMaxWidth, '[data-move][data-media-lg]');
lgMaxWidth.addEventListener("change", function (e) {
    matchMediaHandler(e, '[data-move][data-media-lg]');
});

let mdMaxWidth = window.matchMedia("(max-width: 767.9px)");

matchMediaHandler(mdMaxWidth, '[data-move][data-media-md]');
mdMaxWidth.addEventListener("change", function (e) {
    matchMediaHandler(e, '[data-move][data-media-md]');
});

let smMaxWidth = window.matchMedia("(max-width: 575.9px)");

matchMediaHandler(smMaxWidth, '[data-move][data-media-sm]');
smMaxWidth.addEventListener("change", function (e) {
    matchMediaHandler(e, '[data-move][data-media-sm]');
});

function matchMediaHandler(e, selector) {
    if (e.matches) {
        dataMove(selector);
    } else {
        dataMove(selector, true);
    }
}


//set focus on search input after click on search button (mobile)
let mobileSearchCollapse = document.getElementById('searchOffcanvasTop')
if (mobileSearchCollapse) {
    mobileSearchCollapse.addEventListener('shown.bs.offcanvas', function () {
        $(this).find('input[name="term"]')[0].focus();
    });
}

function dataMove(selector, moveBack = false) {
    const elements = document.querySelectorAll(selector);

    elements.forEach(sourceElement => {
        const target = sourceElement.getAttribute('data-move');
        const targetElement = document.querySelector(target);

        if (targetElement) {
            if (moveBack) {
                moveChildElements(targetElement, sourceElement);
            } else {
                moveChildElements(sourceElement, targetElement);
            }
        }
    });
}

function moveChildElements(sourceElement, destinationElement) {
    while (sourceElement.firstChild) {
        destinationElement.appendChild(sourceElement.firstChild);
    }
}